import { Component, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { ConfigService } from './config.service';

declare var $;

@Component({
	templateUrl: 'login.component.html',
	styleUrls: ['login.component.css']
})
export class LoginComponent implements AfterViewInit {
	message: string;
	userName = 'guest';
	userPassword: string;
	showPassword = false;
	authService: AuthService;
	configService: ConfigService;

	constructor( authService: AuthService, configService: ConfigService, public router: Router) {
		this.authService = authService;
		this.configService = configService;
		this.setMessage();
		this.configService.getAppConfigInfo();	// reset to cookie values
		const userName = this.configService.getUserName();
		const userPassword = this.configService.getUserPassword();
		console.log(userName);
		if ( userName != null && userPassword != null ) {
			this.userName = userName;
			this.userPassword = userPassword;
		}
	}


	// force the screen size to be 100% - css doesn't seem to be getting the job done
	ngAfterViewInit () {
		document.getElementById('loginScreen').style.height =
			(document.documentElement.clientHeight - document.getElementById('topMenu').offsetHeight) + 'px';
	}

	setMessage() {
		this.message = 'Logged ' + (this.authService.isLoggedIn ? 'in' : 'out');
	}

	login() {
		//
		// The user login must match a user/password in the user database OR
		// "guest", which will allow limited access
		//

		this.message = 'Trying to log in ...';
		this.configService.setUserName(this.userName, this.userPassword)

		.subscribe((data) => {
			console.log(data);
			// If data is true, the user has logged in as guest.
			// If data is an object returned by user web services, status will be available.
			if ( data === true || data.status === 'success') {
				// login was successful - save the username and password in auth services
				this.authService.loginSuccessful( this.userName, this.userPassword );
				// Save the authorization key so we know to which screens user should have access.
				this.authService.saveAuthorization ( data.Authorization );
				// Allow config service to set up the user, according to their configuration preferences.
				this.configService.setupUser();
			} else {
				this.message = 'Login failed.';
			}

			this.setMessage();
			if (this.authService.isLoggedIn) {
				// Get the redirect URL from our auth service
				// If no redirect has been set, use the default
				console.log("authService redirectUrl is " + this.authService.redirectUrl);
				const redirect = this.authService.redirectUrl ? this.authService.redirectUrl : '/map';
				const queryParams = this.authService.queryParams;
				console.log("Login successful.  Redirecting to " + redirect, queryParams);
				// Redirect the user
				if ( queryParams?.config && this.configService.realUser) {
					this.configService.readAlternateConfigFile(queryParams.config);
				}
				this.router.navigate([redirect], { queryParams: queryParams });
			} else {
				this.message = this.authService.errMsg || 'Login failed.';
				console.log('setting error message to ' + this.message);
			}
		},
		(err) => this.message = 'Login failed.');
	}

	//
	// If password was previously visible, changes to "****" and vice versa.
	//
	togglePassword() {
		this.showPassword = !this.showPassword;
		if ( this.showPassword === true ) {
			$('#userPassword').attr('type', 'text');
		} else {
			$('#userPassword').attr('type', 'password');
		}
	}

	logout() {
		this.authService.logout();
		this.setMessage();
	}

	// Theoretically, this should display any returned error messages in the login window.
	displayError(errMsg) {
		this.message = this.authService.errMsg;
	}
}
